export default __webpack_public_path__ + "static/media/3-desktop-popup-image-promo-app.a6a4e76d.png";